import { IUser } from 'app/shared/model/user.model';

export interface IImportantUserDetails {
  id?: number;
  physicGoal?: string;
  height?: string;
  weight?: string;
  supplementPrference?: boolean;
  dietPreferrence?: string;
  preferredNonVegDays?: string;
  wakeUpTime?: string;
  bedTime?: string;
  breakfastTime?: string;
  lunchTime?: string;
  dinnerTime?: string;
  workoutTime?: string;
  workTime?: string;
  medicalHistory?: string;
  allergy?: string;
  suggestions?: string;
  address?: string;
  dislikedFoods?: string;
  easilyAvilableFoodSources?: string;
  barbellChestPress?: string;
  barbellShoulderPress?: string;
  deadlift?: string;
  squats?: string;
  barbellBicepsCurls?: string;
  hamstringsCurls?: string;
  tricepCablePushDown?: string;
  latpulldown?: string;
  confirmationDigitalSignature?: boolean;
  user?: IUser;
}

export const defaultValue: Readonly<IImportantUserDetails> = {
  supplementPrference: false,
  confirmationDigitalSignature: false,
};
